export default __webpack_public_path__ + "static/42aa-893f0015ed392ec0dca2c7ee5abcad7c.png";